var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};


/**
 * Backbone view that renders the proposal form
 *
 * @class Curriculog.ProposalForm.FormView
 * @augments CurriculogView
 */
Curriculog.ProposalForm.FormView = (function ($, _, Backbone, FormView) {

	FormView = Curriculog.CurriculogView.extend({
		el: function() {
			return $('#curriculog-fields-column');
		},

		events: {
			'click .curriculog-save-widget': 'saveAll',
			'click .curriculog-launch-widget': 'launch',
			'click #curriculog-print-widget': 'print',
		},

		/**
		 * Form initialization
		 *
		 * @param {object} options - init options
		 * @param {object} options.userPermissions - various user permissions
		 * @param {collection} options.curricula - Curriculum collection
		 */
		initialize: function (options) {
			this.$form = this.$el.find('#curriculog-fields-column-content');
			this.addMask(this.$form, 'Loading the proposal', '50');

			this.userPermissions = options.userPermissions;
			this.curricula = options.curricula;
      this.print_popup = null;
      this.cui_enabled = options.cui_enabled;


			this.trackingDropdown = new Curriculog.ProposalToolbox.TrackingDropdown();
			this.toolbar = new Curriculog.ProposalForm.Toolbar({proposal: this, cui_enabled: this.cui_enabled});

			this.model = new Curriculog.Proposal({
				id: Number($('#proposalId').val()),
				parentId: Number($('#proposalParentId').val()),
				approvalProcessId: Number($('#approvalProcessId').val()),
				crosslisted: Boolean(+$('#crosslisted').val()),
				crosslistingRequireReview: Boolean(+$('#crosslistingRequireReview').val()),
				status: $('#status').val(),
				type: $('#proposal-type').val(),
				waitingSig: $('#waitingSig').val(),
				originator: Number($('#originator').val()),
				user: Number($('#user').val()),
				currentStepId: Number($('#currentStepId').val()),
				proposalName: $('#proposalName').val(),
				entities: $('#entities').val(),
				decision: $('#decision').val(),
				s3Operation: $('#s3-operation').val(),
				s3File: $('#s3-file').val(),
				acalogGateway: $('#acalogGateway').val(),
				agendaId: Number($('#agendaId').val()),
				crosslistingEnabled: $('#crosslistingEnabled').val(),
				createAssessments: Boolean(+$('#createAssessments').val()),
				showHelp: false
			});

			this.model.fields = new Curriculog.ProposalForm.FieldModels();

			this.listenTo(Backbone, 'change:title', this.setTitle);
			this.listenTo(Backbone, 'change:activity', this.setActivity);
			this.listenTo(Backbone, 'form:stretch', this.resizeForm);
			this.listenTo(Backbone, 'form:reload', this.reload);
			this.listenTo(Backbone, 'form:reset', this.hideTracking);
			this.listenTo(this.model, 'change:decision', this.decisionChange);
			$(window).on("resize", _.bind(this.resizeForm, this));
			window.onbeforeunload = _.bind(this._onbeforeunload, this);

			this.disableSubmit();
			this.bindLogout();
			this.render();
		},

		/**
		 * Delegates rendering to the sections and therefore fields
		 *
		 * @return {promise}
		 */
		render: function () {
			// Init Sections
			var that = this,
				promises = [],
				defer = $.Deferred();

			this.setElement($('#curriculog-fields-column'));

			// Free the section and field objects
			this.destroySections();

			// Fully load all views, then stretch
			promises = this.renderSections();

			$.when.apply($, promises).done(function() {
				Backbone.trigger('form:stretch');

				that.fadeIn().done(
					defer.resolve,
					function(){
						Curriculog.Actions.log('proposal-form-loaded');
					});

				that.removeMask(that.$form);
			});
			return defer.promise();
		},

		/**
		 * Renders each section sequentially
		 *
		 * @return {Array} - promises
		 */
		renderSections: function () {
			var promises = [],
				sections = this.$el.find('.section');
			if (sections.length > 0) {
				promises = _.map(sections, this.renderSection, this);
			}
			return promises;
		},

		/**
		 * Renders a particular section
		 *
		 * @return {promise}
		 */
		renderSection: function(section) {
			var itemView = new Curriculog.ProposalForm.Section({
				section: section,
				proposal: this.model,
				userPermissions: this.userPermissions,
				curricula: this.curricula,
				formView: this
			});
			this.sectionViews.push(itemView);
			return itemView.render();
		},

		/**
		 * Destroys all subviews.
		 *
		 * @returns {[type]} [description]
		 */
		destroySections: function() {
			_.map(this.sectionViews, function(section) {
				section.remove();
			});
			this.sectionViews = [];
			this.model.fields.reset();
		},

		/**
		 * Hooks into Backbones native remove to also destroy the sub views.
		 */
		remove: function() {
			this.destroySections();
			$(window).off("resize", this.resizeForm);
			return Curriculog.CurriculogView.prototype.remove.apply(this, arguments);
		},

		/**
		 * Utility to reload the form
		 *
		 * @return {promise}
		 */
		reload: function () {
			if (this.trackingDropdown.mode == 'current') {
				return this.getForm();
			} else { // original, currentMarkup
				return this.getTrackedForm();
			}
		},

		/**
		 * Load and display the standard form
		 *
		 * @return {promise}
		 */
		getForm: function () {
			var that = this,
				defer = $.Deferred();

			$.ajax({
				url: '/proposal:'+ this.model.id +'/ajax/viewForm',
				type: 'GET',
				data: {
					display: 'getForm',
					userId: this.model.get('user')
				},
				beforeSend: function() {
					that.addMask(that.$form, 'Loading the proposal', '50');
				},
				success: function(result) {
					that.$form.html(result);
					that.render().done(function() {
						// (legacy) update the curriculum. canEdit/richText are globals... yuck
						resetCurriculum(canEdit, richText);
						that.setTitle();
						defer.resolve();
					});
				}
			});
			return defer.promise();
		},

		/**
		 * Load and display the form with tracking details. Hopefully, one day,
		 *    this can be merged with getForm. But for now the backend doesnt
		 *    support it.
		 *
		 * @return {promise}
		 */
		getTrackedForm: function () {
			var that = this,
				defer = $.Deferred(),
				mode = this.trackingDropdown.mode,
				edits = this.trackingDropdown.edits;

			if (edits !== false) {
				edits = JSON.stringify(edits);
			}

			$.ajax({
				url: '/proposalTracking:' + this.model.id + '/trackEditsDiff',
				type: 'GET',
				data: {
					display: 'getFormAndUsers',
					showMarkup: 1,
					showOriginal: mode,
					edits: edits
				},

				beforeSend: function() {
					that.addMask(that.$form, 'Loading the proposal', '50');
				},

				success: function(result) {
					result = $(result);
					var form = result.filter('#form').html(),
						files = result.filter('#files').html(),
						styles = result.filter('#editor-styles').html(),
						users = result.filter('#edits-filter-select').html(),
						tooltips = result.filter('#edit-tooltips');

					// form
					that.$form.html(form);

					// files
					if ($('.tab-content-item.active').attr('id') === 'comments') {
						$('#files-content-markup').remove();
						$(files).insertAfter($('#curriculog-steps-column-content #tracking'));
					} else {
						$('#files-content-markup').html(files);
					}

					// styles
					$('#editor-styles').append(styles);

					// tooltips
					that.$form.append(tooltips);
					that.initTrackingMarkup();

					// (legacy) curriculum tracking is separate for the time being
					resetCurriculum(0, richText, edits);

					if (edits === false) {
						// user dropdown (refresh to fill it)
						$('#edits-filter-select').html(users);
						that.trackingDropdown.render();
					}
					that.render().done(defer.resolve);
				}
			});
			return defer.promise();
		},

		/**
		 * Tracking helper that sets up the edit labeling tooltips for the
		 * tracking view
		 *
		 * @returns {undefined}
		 */
		initTrackingMarkup: function() {
			// Not sure what this was here for in the original code
			// $('.qtip .edit-tooltip').closest('.qtip').remove();
			$('.edit-tip').each(function(){
				var id = $(this).data('id');
				$(this).qtip({
					content: $('.edit-tooltip.edit-' + id).clone(),
					show: {ready: false},
					style: {tip: true}
				});
			});
		},

		/**
		 * Used to return a list of all field views
		 *
		 * @return {Array} - A list of field view objects
		 */
		getFieldViews: function() {
			var fields = [];
			_.each(this.sectionViews, function(sectionView, index) {
				_.each(sectionView.itemViews, function(fieldView, index) {
					fields.push(fieldView);
				});
			});
			return fields;
		},

		/**
		 * Used to return a list of all field models
		 *
		 * @param   {[Array]} fields - OPTIONAL: a list of fields to filter down.
		 * @return {Array} - A list of field model objects
		 */
		getFieldModels: function(fields) {
			fields = fields || this.getFieldViews();
			return _.pluck(fields, 'model');
		},

		/**
		 * Used to get a list of field views that are currently in edit mode.
		 *
		 * @param   {[Array]} fields - OPTIONAL: a list of fields to filter down.
		 * @returns {Array} - A list of field views that are in edit mode.
		 */
		getFieldsInEditMode: function(fields) {
			fields = fields || this.getFieldViews();
			return _.where(fields, {mode: 'edit'});
		},

		/**
		 * Returns all fields that have unsaved changes to their values.
		 *
		 * @param   {[Array]} fields - OPTIONAL: a list of fields to filter down.
		 * @returns {Array} - A list of field views
		 */
		getUnsavedFields: function(fields) {
			fields = fields || this.getFieldViews();
			return _.filter(fields, function(field) {
				return field.hasUnsavedChanges();
			});
		},

		/**
		 * Used to get the proposals program type for the curriculum field
		 *
		 * @return {Number} - (-1) Unknown | (0) program | (1) shared core
		 */
		getProgramType: function(returnType) {
			if (this.model.get('type') !== 'program') {
				return -1;
			}

			var programTypeModel = _.find(this.getFieldModels(), function(model){
				return model.get('systemRequired') == 'programType';
			});

			// If this is an old AP or shared cores are turned off in the
			// system settings.
			if (!programTypeModel) {
				return 0;//program
			}

			var programType = parseInt(programTypeModel.get('value'), 10);

			return isNaN(programType) ? -1 : programType;
		},

		/**
		 * Returns the field associated with that system required type
		 *
		 * @param   {String} field_type - The systemRequired model attribute value to look for
		 * @returns {View}              - Field view
		 */
		getSystemRequiredField: function(field_type) {
			return _.find(this.getFieldViews(), function(field){
				return field.model.get('systemRequired') == field_type;
			});
		},

		/**
		 * Find and return a field view by id
		 *
		 * @param  {Number} id - the fields id
		 * @return {Object|undefined} - a field view or undefined if not found
		 */
		getField: function(id) {
			return _.find(this.getFieldViews(), function(field) {
				return field.model.id == id;
			});
		},

		/**
		 * Save all fields at once. Does not validate (anymore). Only used for
		 * unlaunched proposals.
		 *
		 * @returns {Promise} - A promise that will complete when saving is
		 * finished. Slightly more valuable than a wing and a prayer.
		 */
		saveAll: _.debounce(function(options) {
			var fields = [],
				unsaved_fields = this.getUnsavedFields(),
				models = _.pluck(unsaved_fields, 'model'),
				proposal = this,
				// elements = [],
				saves = [],
				defer = $.Deferred(),
				default_options = {
					noMask: false // Use when you dont want to automatically add a mask to the form
				};

			options = _.defaults(options || {}, default_options);

			_.each(unsaved_fields, function(field){
				var model = field.model,
					value = field.getValue();

				model.set({value: value});

				fields.push({
					id: model.id,
					value: value
				});

			});

			if (!options.noMask) {
				this.addMask(this.$form, 'Saving Fields', '50');
			}

			// Save assessments
			saves.push(assessmentObject.saveAllChanges());

			// save curriculum
			if (app.cv) {
				saves.push(app.cv.saveAll());
			}

			// Save all other fields
			if (unsaved_fields.length) {
				saves.push($.ajax({
					url: '/proposalField/updateMany',
					type: 'POST',
					data: {
						proposal_id: proposal.model.id,
						fields: JSON.stringify(fields)
					}
				}));
			}

			// Reload the form when everything is done.
			$.when.apply($, saves).done(function(){
				// Check for fields that are conditional or the proposal entity
				var loading_promises = [];
				var reload_steps = _.filter(models, function(model) {
					return model.get('conditional') || model.get('systemRequired') == 'proposalEntity';
				});
				var program_type = _.find(models, function(model) {
					return model.get('systemRequired') == 'programType';
				});

				// Reload the steps flyout if conditional or entity fields were
				// updated.
				if (reload_steps.length) {
					loading_promises.push(proposalObject.ajaxTab('history'));
				}


				// Reset the change cache on each saved field
				_.each(unsaved_fields, function(field){
					field._unsaved_changes = false;
					field.$el.removeClass('field-unsaved');
				});

				// Reset curriculum change detection
				if (app.cv) {
					app.cv.applyUnsavedColor();
				}

				// Switch the program type before reloading the form
				if (program_type) {
					var isSharedCore = +program_type.get('value');
					Backbone.trigger('change:programType', isSharedCore);
				}

				function _finalize() {
					Backbone.trigger('change:title');
					Backbone.trigger('change:activity');
					// Reset assessment change detection
					assessmentObject.precacheValues();
					Curriculog.Actions.log('proposal-all-fields-saved');
					defer.resolve();
				}

				// Reload the form
				loading_promises.push(proposal.getForm());

				$.when.apply($, loading_promises).done(_finalize);
			});

			return defer.promise();
		}, 2000, true),

		launch: function(){
			this.toolbar.launch();
		},

		/**
		 * Checks passed in validation and pops a launch dialog if it was successful
		 *
		 * @private
		 * @param {Object[]} errorObj - an array of error objects returned from the validation promises
		 * @param {Array|String} errorObj[].messages - A string or array of strings if there are errors
		 * @param {Array|Element|Func|Null} errorObj[].elements - An element or array of elements or func.
		 *            Executes/Goes to this with the Show Mebutton
		 *
		 * This function is passed the return object of each validation promise.
		 * Each object has two properties, messages and elements:
		 * [
		 *     {messsages: ['something broke', 'yup'], elements: $('#broke-field')},
		 *     {messsages: 'more', elements: null},
		 *     {messsages: '666', elements: function(){return $('#more-brokes')}}
		 * ]
		 */
		_launch: function(/* dynamic arguments */){
			var launchDialog = Curriculog.ProposalForm.LaunchDialog,
				crosslisted = this.model.get('crosslisted'),
				requireReview = this.model.get('crosslistingRequireReview'),
				decision = 'launch';

			// get a flat list of error messages
			var messages = _.chain(arguments).pluck('messages').flatten().filter().uniq().value();

			// get a flat list of non empty error elements
			// 1. Pluck each list of elements from the objects passed in as arguments.
			// 2. Flatten the list so we can iterate over them cleanly.
			// 3. Pull the DOM elements out of the jquery objects (creates an array of arrays again)
			// 4. Strip out empty values.
			// 5. Flatten the list again.
			// 6. Profit
			var elements = $(_.chain(arguments).pluck('elements').flatten().map(function (element) {
				return $(element).toArray();
			}).filter().flatten().value());

			if (messages.length) {
				new Curriculog.ProposalForm.LaunchErrorDialog({
					elements: elements,
					messages: messages
				});
				return;
			}

			if (crosslisted && requireReview) {
				launchDialog = Curriculog.ProposalForm.LaunchReviewDialog;
				decision = 'review';
			}

			new launchDialog()
				.done(_.bind(this.decide, this, decision));
		},

		/**
		 * Saves a decision to the model. This needs to be moved to the steps
		 * when they are implemented.
		 *
		 * @param  {String} decision - the textual representation of the decision
		 * @return {xhr}
		 */
		decide: function(decision) {
			this.addMask($('#curriculog-page'), 'Loading the proposal', '50');
			return this.model.save({decision: decision}, {wait: true}).done(function(){
				Curriculog.Actions.log('proposal-decision-saved');
			});
		},

		/**
		 * Utility for use in synchronous validation functions. Returns a resolved promise
		 * with the passed in `elements` and `messages` as the promises value.
		 *
		 * @param   {array} elements - An array of DOM nodes, NOT jquery nodes/selectors
		 * @param   {array} messages - An array of strings representing errors
		 * @returns {Promise}        - Resolved promise with {elements: array, messages: array}
		 */
		_sync_validation: function(elements, messages) {
			return $.Deferred().resolve({
				'elements': elements,
				'messages': messages
			}).promise();
		},

		/**
		 * Launch validation for fields: checks edit mode / validation errors.
		 *
		 * @return {promise}
		 */
		validateFields: function() {
			var views = this.getFieldViews(),
				models = this.getFieldModels(views),
				invalid_models = [],
				messages = [],
				proposal = this,
				elements = [];

			invalid_models = _.reject(models, function(model){
				return model.isValid(true);
			});

			if (invalid_models.length) {
				elements = elements.concat(_.map(invalid_models, function(model) {
					return proposal.getField(model.id).el;
				}));
				messages.push('Proposal has validation errors');
			}

			return this._sync_validation(elements, messages);
		},

    /***
     * Display a warning for unlaunched proposals created before release of
     * Originator Tracking feature
     ***/
    displayOriginatorTrackingWarning: function(launching) {
      var deferred = $.Deferred();
      var message = "This proposal does not have tracking available while it is " +
      "unlaunched. To take advantage of this feature you will need to recreate " +
      "your proposal.";
      if ($('#displayOriginatorTrackingWarning').val() == 1) {
        var dialog = objDialog.createBasicWarningDialog(
          'originator-tracking-warning',
          function(dialog, defaults) {
            $(dialog).append(message);
            if (launching) {
              defaults.buttons = {
                'Launch': function() {
                  $(this).dialog('close');
                  deferred.resolve();
                },
                'Cancel': function() {
                  $(this).dialog('close');
                  deferred.reject();
                }
              };
            } else {
              defaults.buttons = {
                'Ok': function() {
                  $(this).dialog('close');
                  deferred.resolve();
                },
                'Cancel': function() {
                  $(this).dialog('close');
                  deferred.resolve();
                }
              };
            }
            $(dialog).dialog(defaults);
          }
        );
      } else {
        deferred.resolve();
      }

      return deferred.promise();
    },

		/**
		 * Launch validation for conditional steps.
		 *
		 * @return {promise}
		 */
		validateConditionalSteps: function(){
			var deferred = $.Deferred(),
				that = this,
				data = {
					messages: [],
					elements: []
				};

			if (! $('.step.step-conditional').length){
				return deferred.resolve(data).promise();
			}

			$.ajax({
				url: '/proposal:' + this.model.id + '/oneConditional.json',
				type: 'GET',
				success: function(result) {
					if (Number(result.error) === 1) {
						data.messages.push('Proposal has no steps');
					}
					deferred.resolve(data);
				}
			});

			return deferred.promise();
		},

		/**
		 * Launch validation that checks for missing participants
		 *
		 * @return {promise}
		 */
		validateParticipants: function(){
			var messages = [],
				user_errors = $('.no-users-error, .no-agenda-admin-error,' +
					'.missing-agenda-admin, .missing-committees');

			// Make sure we arent missing users by checking for errors that would
			// be added to the steps dom when changing the entity field
			// TODO: Look at the steps model validation in backbone
			if (user_errors.length) {
				messages = ['Proposal is missing participants'];
				// messages.push('At least one step in this proposal is missing the required participants. Please check your proposal information to ensure you have selected the proper entity. If you are sure your data is correct, please contact an administrator.');
			}

			return this._sync_validation(user_errors, messages);
		},

		/**
		 * Launch validation that checks for assessments
		 *
		 * @return {promise}
		 */
		validateAssessments: function(){

			var message = '',
				noItem = $(".no-item"),
				proposalOutcomes = $('.proposalOutcomes'),
				proposalObjectives = $('.proposalObjectives'),
				dataRequired = 0;

			if (noItem.length == 1 && proposalOutcomes.length !== 0){
				dataRequired = proposalOutcomes.data('required');
				displayText = noItem.find('.legend').val();
			} else if (noItem.length == 1 && proposalObjectives.length !== 0){
				dataRequired = proposalObjectives.data('required');
				displayText = proposalObjectives.data('display-text');
			};		
			
			if (dataRequired !== undefined && dataRequired === 1) {
				var span = $("<span class='error'>" + displayText + " is required.</span>");
				noItem.append(span);
				var message = 'Proposal has validation errors';
			}

			return this._sync_validation(noItem, message);
		},

		/**
		 * Launch validation crosslisting fields and missing participants
		 *
		 * @return {promise}
		 */
		validateCrosslisting: function() {
			var deferred = $.Deferred(),
				that = this,
				data = {
					messages: [],
					elements: []
				};

			$.ajax({
				url: '/proposal:' + this.model.id + '/validateCrosslisting.json',
				type: 'PUT',
				success: function(result) {
					if (result.success !== true) {
						data.messages = result.errors;
					}
					deferred.resolve(data);
				}
			});

			return deferred.promise();
		},

		/**
		 * Event handler for decision changes that redirects/notifies the user
		 * FIXME: This needs to be moved to the decision view/model
		 *
		 * @param {Object} model - the current form model
		 * @param {string} decision - the new decision
		 * @param {Object} options - unused
		 * @return {undefined}
		 */
		decisionChange: function(model, decision, options) {
			var status = model.get('status'),
				error = model.get('error');

			// TODO: refactor this stuff, it was copied over from the old way
			if (this.model.hasChanged('decision')) {
				if (error == 1) {
					/*
					 *  Stale Data. This happens when the current step ID on the
					 *  page is outdated because someone made a step moving decision
					 *  on the proposal since the page was loaded.
					 */
					this.showGrowl(
						'Unauthorized',
						'The step you are making this decision on has moved on already. '+
						'Please refresh your page to retrieve the newer data.'
					);

				} else if (error == 2) {
					/*
					 *  The decision caused the step to change and you no longer
					 *  have permission to view this proposal because of restricted
					 *  transparency.
					 */
					setFlashMessage({
						title: 'This proposal has moved on',
						text: 'This proposal has moved on in the workflow.',
						callback: function () {
							location.href = '/proposals';
						}
					});

				} else if (this.model.hasChanged('currentStepId') || status == 'waiting' || decision == 'review') {
					/*
					 *  The decision caused the step to change. Reload the form to
					 *  update the form data. This can be removed and we can update
					 *  the models/views but we need to take a few areas into
					 *  consideration:
					 *     Form styles - colored task side bar
					 *     Form model data - current step id, etc
					 *     Toolbar buttons
					 *     Cached user permissions?
					 */
					setFlashMessage({
						title: 'This proposal has moved on',
						text: 'This proposal has moved on in the workflow.',
						callback: function () {
							// We currently arent using a full model based view, so we have to reload to resync the form
							location.reload(true);
						}
					});

				} else if (decision == 'delete') {
					/*
					 *  The proposal has been deleted so it is no longer accessable.
					 */
					setFlashMessage({
						title: 'This proposal has been deleted',
						text: 'This proposal has been deleted from Curriculog.',
						callback: function () {
							location.href = '/proposals';
						}
					});

				} else if (status == 'completed') {
					/*
					 *  The proposal is completed, reload the page to refresh the
					 *  proposal data. This can also be removed eventually. See
					 *  notes from the hasChanged(currentStepId) condition above.
					 */
					setFlashMessage({
						title: 'This proposal is complete',
						text: 'This proposal has been completed. ' +
							'There is no more work to be done on it at this time.',
						callback: function () {
							// We currently arent using a full model based view, so we have to reload to resync the form
							location.reload(true);
						}
					});

				} else {
					/*
					 *  The decision did not move the step. Just reload the
					 *  decisions panel to show your decision.
					 */
					proposalObject.ajaxTab('decisions');
				}

			Curriculog.Actions.log('proposal-decision-saved');
			}
		},

		/**
		 * Update the proposal title when a title field changes
		 */
		setTitle: function() {
			var fieldModels = this.getFieldModels();
			// Each field model has an integer attibute `title`. If the `title`
			// attribute is greater than zero, it is used as a title field in
			// the order of its numerical value.
			// Pull out all fields that are title fields and sort by the title
			// position. Then pull off the title value and join them together.
			var title = _.chain(fieldModels)
				.map(function(model) {
					if (model.get('title') > 0) {
						return model;
					}
				})
				.filter()
				.sortBy(function(model) {
					return model.get('title');
				})
				.invoke('getDisplayValue')
				.value();

			title = title.join(' - ');

			// Page heading
			$('#curriculog-fields-column-process-name').text(title);
			// Hidden input (legacy)
			$('#proposalName').val(title);
			// Proposal model
			this.model.set({proposalName: title});
		},

		/**
		 * Update the steps activity record
		 */
		setActivity: function() {
			// HACK! Fix when steps have been converted to backbone
			$('#step-' + this.model.get('currentStepId') + ' .activity .activity-changes').text('Yes');
		},

		/**
		 * Resizes the form/page to accomodate height changes from altering the DOM
		 */
		verticalStretch: function() {
			if (!this.cui_enabled) {
				var col1 = '#curriculog-fields-column-content',
				col2 = '#curriculog-steps-column-content',
				minHeight = 800;

				// get accurate column height, cross-browser
				document.getElementById('curriculog-fields-column-content').overflow = "scroll";
				document.getElementById('curriculog-steps-column-content').overflow = "scroll";
				var col1Height = document.getElementById('curriculog-fields-column-content').scrollHeight;
				var col2Height = document.getElementById('curriculog-steps-column-content').scrollHeight;
				document.getElementById('curriculog-fields-column-content').overflow = "";
				document.getElementById('curriculog-steps-column-content').overflow = "";

				// Set the new height to the tallest column.
				var newHeight = Math.max(col1Height, col2Height, minHeight);

				$(col2).height(newHeight);
				$(col1).height(newHeight);
			}
		},

		/**
		 * Fades in each of the sections.
		 *
		 * @return {promise}
		 */
		fadeIn: function() {
			var deferred = $.Deferred();

			_.each(this.sectionViews, function(section, index) {
				section.$el.css('visibility', 'visible')
					.hide()
					.fadeIn('slow', function() {
						return deferred.resolve();
					});
			});

			return deferred.promise();
		},


		/**
		 * Save All button that floats at the bottom of the form
		 */
		floatToolbar: function() {

			function onScroll() {
				var scroll_top = $w.scrollTop(),
					scroll_bottom = scroll_top + viewport_height,
					float_position = scroll_bottom - toolbar_height;

				// If you have scrolled past the footer position stick it in place.
				if (scroll_bottom >= max_toolbar_bottom) {
					toolbar.css({top: 'auto'});
				} else {
					// The offset function sets the elements relative position
					// given an absolute position passed in.
					toolbar.offset({top: float_position});
				}
			}

			// return if this proposal is not unlaunched
			if ((this.model.get('status') !== 'unlaunched')) {
				return;
			}

			var $w = $(window),
				toolbar = $('#curriculog-fields-column-toolbar-save'),
				toolbar_height = toolbar.outerHeight(),
				viewport_height = $w.height();

			// Position the toolbar at the bottom of the form.
			toolbar.css({top: 'auto', position: 'relative'});

			// Now that the toolbar is at the bottom we can stash its position
			// to know when to stop floating it.
			var toolbar_top = toolbar.offset().top,
				max_toolbar_bottom = toolbar_top + toolbar_height;

			$w.off('scroll.floatToolbar');

			// Dont bind the scroll event if the page isnt long enough to need it.
			if (max_toolbar_bottom < viewport_height) {
				return;
			}

			// Position the toolbar on first load
			onScroll();

			// Establish the scroll events for subsequent positioning
			$w.on('scroll.floatToolbar', onScroll);
		},

		/**
		 * Actions taken if the form viewport is adjusted after
		 * initial page render
		 */
		resizeForm: function() {
			this.verticalStretch();
			this.floatToolbar();
		},

		/**
		 * Checks if the form is currenly in tracking mode
		 *
		 * @return {Boolean}
		 */
		trackingShown: function() {
			return this.trackingDropdown.mode !== 'current';
		},

		/**
		 * Turns off tracking view and reloads the form
		 *
		 * @return {promise}
		 */
		hideTracking: function() {
			if (! this.trackingShown()) {
				return false;
			}
			this.trackingDropdown.reset();
			return this.reload();
		},

		/**
		 * Returns a boolean of whether or not any field has unsaved changes
		 *
		 * @returns {Boolean}
		 */
		hasUnsavedChanges: function() {
			var unsaved_fields = this.getUnsavedFields(),
				unsaved_curriculum = app.cv ? app.cv.hasUnsavedChanges() : false,
				unsaved_assessments = assessmentObject.hasUnsavedChanges();
			return unsaved_fields.length || unsaved_curriculum || unsaved_assessments;
		},

		/**
		 * Event handler that attempts to autosave the form data. If a save is
		 * not successful, throws a warning that gives the user an option to
		 * stay on the page and not lose data.
		 *
		 * @param   {Event} event
		 * @returns {String|undefined} - The message to show the users if there
		 *                               is an error saving. Undefined to allow
		 *                               them to leave.
		 */
		_onbeforeunload: function(event) {
			var msg = "You have unsaved changes on this page. If you navigate away these changes will be lost.";

			event = event || window.event;

			function throw_dialog() {
				// For IE6-8 and Firefox prior to version 4. Not really needed since we dont support these browsers
				if (event) event.returnValue = msg;
				// For Chrome, Safari, IE8+ and Opera 12+
				return msg;
			}

			// If there are any unsaved changes, ask the user to confirm navigating away.
			if (this.hasUnsavedChanges()) {
				return throw_dialog();
			}

			// Returning undefined (or nothing) tells the browser to navigate without a warning.
			return undefined;
		},

		/**
		 * Confirm logging out if there are unsaved changes.
		 */
		bindLogout: function() {
			var that = this;
			$('#logout').on('click', function (event) {
				if (! that.hasUnsavedChanges()) {
					return true;
				}
				if (that._logout_dialog) {
					that.stopEvent(event, true);
					return false;
				}

				that._logout_dialog = new Curriculog.ProposalForm.LogoutConfirmDialog({
					form: that
				});

				that.stopEvent(event, true);
				return false;
			});
		},

		/**
		 * Disables form submission BECAUSE AJAX!
		 */
		disableSubmit: function() {
			var that = this;
			$('#curriculog-proposal').on('submit', function (event) {
				that.stopEvent(event);
				return false;
			});
		},

    /**
     * Opens the proposal print popup
     *
     * @param  {Event} [event]
     */
    print: function(event) {
        if(this.cui_enabled) {
          this.stopEvent(event);
          if (this.print_popup && !this.print_popup.isClosed()) {
              this.print_popup.reload().focus();
              return;
          }

          this.print_popup = new Curriculog.PopupWindow({
              url: '/proposal:' + this.model.id + '/print',
              width: 800,
              height: 500
          });
        }

    },

	});

	return FormView;

})($, _, Backbone, Curriculog.ProposalForm.FormView || {});
